import * as actionTypes from "~/store/action_types";

const files_filters = (state = {}, action) => {
  switch (action.type) {
    case actionTypes.FETCH_FILES_FILTERS_SUCCESS: {
      const { response = {}, projectId } = action;
      const { uploader } = response;
      if (uploader) {
        const uploaderIds = Object.values(uploader).map((singleUploader) => singleUploader.id);
        return {
          ...state,
          [projectId]: { ...response, uploader: uploaderIds },
        };
      }
      return state;
    }
    default:
      return state;
  }
};

export default files_filters;
